import type { ConfigurationValidationError } from '@festina/configuration-general-types/configuration'
import { useCallback } from 'react'

import { isTemplateDependencyValidationError } from '../../uiModels/types'
import type { SpecialCasedSubTemplatedValueSetup } from '../specialCasedSubTemplatedViewers/types'

/**
 * Utility hook used to determine if an error belongs a special cased subtemplated field value. This has been put inside a hook since
 * we'll need to read from the template context and the configuration context once we want to support error
 * mappings being shown in flattened views.
 */
export const useIsErrorForSpecialCasedSubTemplatedFieldValue = () =>
  useCallback(
    (
      data: SpecialCasedSubTemplatedValueSetup,
      error: ConfigurationValidationError,
    ) => {
      if (!isTemplateDependencyValidationError(error)) {
        return false
      }

      const variant = data.field.value?.variants?.find(
        (variant) =>
          variant.subTemplateIdentifier === data.subTemplateIdentifier,
      )

      return !!variant && (error.path ?? '').startsWith(variant.path)
    },
    [],
  )
